import React, { useState, useMemo } from "react";
import styles from "./styles.module.scss";
import cn from "classnames";
import useJobResources from "@/hooks/useJobResources";

// SVG icons (SVGR must be configured)
import Plus from "@/assets/Plus.svg";
import Search from "@/assets/Search.svg";

export const JobResourceBody = ({ className, title }) => {
  const items = useJobResources();
  const [query, setQuery] = useState("");

  // 🔍 Filter items based on search query
  const filteredItems = useMemo(() => {
    if (!query.trim()) return items;
    const lower = query.toLowerCase();
    return items.filter((item) =>
      [item.Title?.toLowerCase(), item["Job Type"]?.[0]?.toLowerCase(), item.Content?.toLowerCase()].some((text) =>
        text?.includes(lower),
      ),
    );
  }, [items, query]);

  return (
    <section className={cn(styles.JobResourceBody, className)}>
      {/* Search Bar */}
      <div className={styles.searchBar}>
        <div className={styles.searchInput}>
          <div className={styles.searchIcon}>
            <Search />
          </div>
          <input
            type="text"
            placeholder="Search by keywords"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className={styles.searchField}
          />
        </div>
      </div>

      {/* Content + JumpNav */}
      <div className={styles.contentWrapper}>
        {/* Jump Navigation */}
        <div className={styles.jumpNav}>
          <span>JUMP TO</span>
          <div className={styles.jumpLinks}>
            <div>Section 1</div>
            <div>Section 2</div>
            <div>Section 3</div>
          </div>
        </div>

        {/* Main Content */}
        <div className={styles.content}>
          {title && <h2 data-sourceflow-prop="title">{title}</h2>}

          <div className={styles.cardGrid}>
            {filteredItems.map((item, i) => (
              <a key={i} href={`/job-resources/${item.url_slug}`} className={styles.card}>
                {item.Image?.url && <img src={item.Image.url} alt={item.Title || "Job image"} />}

                <div className={styles.cardInner}>
                  <div className={styles.cardHeader}>
                    <div className={styles.cardTag}>
                      <span>{item["Job Type"]?.[0]}</span>
                    </div>
                    <div className={styles.cardDate}>
                      {item["Publish Date"] &&
                        new Date(item["Publish Date"]).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })}
                    </div>
                  </div>

                  <div className={styles.cardTitle}>{item.Title}</div>

                  {item.Content && (
                    <div className={styles.cardContent} dangerouslySetInnerHTML={{ __html: item.Content }} />
                  )}

                  <div className={styles.readMore}>
                    <span>READ MORE</span>
                    <div className={styles.arrowIcon}>
                      <Plus />
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {filteredItems.length === 0 && <p className={styles.noResults}>No results found.</p>}
        </div>
      </div>
    </section>
  );
};

export default JobResourceBody;
